import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useParams, useLocation } from "react-router-dom";
import _ from "lodash";
import DataTableBase from "../../common/Datatable";
import makeRequest from "../../../../api";
import { assessmentService, userService } from "../../../../api/services";
import { toast } from "react-toastify";

const healthMetricsMap = {
  FASTING_BLOOD_SUGAR: "-",
  HBA1C: "-",
  POSTPRANDIAL: "-",
  BMI: "-",
  WEIGHT: "-",
};

const UserMetricsPage = () => {
  const params = useParams();
  const userId = params.userId;
  const subscription = useLocation().state;

  const [metrics, setMetrics] = useState<any>([]);
  const [userDetails, setUserDetails] = useState<any>(null);

  const fetchMetrics = async () => {
    try {
      const res = await makeRequest(
        assessmentService.getUserHealthMetricsList(userId)
      );
      const response = res?.data?.body;
      const metricsList = Object.keys(response).map((item: any) => {
        const key = item as keyof typeof response;
        const data = response?.[key];
        let metrics = {
          ...healthMetricsMap,
        };
        data?.forEach((item: any) => {
          metrics = {
            ...metrics,
            [item?.name]: item?.value,
          };
        });
        return {
          date: item,
          metrics,
        };
      });
      metricsList?.sort((a: any, b: any) => {
        const timeA = moment(a?.date, "DD-MM-YYYY").valueOf();
        const timeB = moment(b?.date, "DD-MM-YYYY").valueOf();
        return timeB - timeA;
      });
      setMetrics([...metricsList]);
    } catch (error: any) {
      toast.error("Error fetching user health metrics!");
    }
  };

  const getUserData = async () => {
    try {
      const res = await makeRequest(userService.getUserDetails(userId));
      setUserDetails({ ...res?.data?.userDto });
    } catch (error: any) {
      toast.error("Error fetching user details!");
    }
  };

  useEffect(() => {
    if (userId) {
      fetchMetrics();
      getUserData();
    }
  }, [userId]);

  const columns = [
    {
      name: "Date",
      selector: (row: any) => row.date,
      cell: (row: any) => {
        return (
          <div>{moment(row?.date, "DD-MM-YYYY")?.format("DD MMM YYYY")}</div>
        );
      },
    },
    {
      name: "Body weight",
      selector: (row: any) => row?.metrics?.WEIGHT,
      cell: (row: any) => {
        return <div>{row?.metrics?.WEIGHT}</div>;
      },
    },
    {
      name: "BMI",
      selector: (row: any) => row?.metrics?.BMI,
      cell: (row: any) => {
        return <div>{row?.metrics?.BMI}</div>;
      },
    },
    {
      name: "Post prandial",
      selector: (row: any) => row?.metrics?.POSTPRANDIAL,
      cell: (row: any) => {
        return <div>{row?.metrics?.POSTPRANDIAL}</div>;
      },
    },
    {
      name: "Fasting blood sugar",
      selector: (row: any) => row?.metrics?.FASTING_BLOOD_SUGAR,
      cell: (row: any) => {
        return <div>{row?.metrics?.FASTING_BLOOD_SUGAR}</div>;
      },
    },
    {
      name: "HBA1C",
      selector: (row: any) => row?.metrics?.HBA1C,
      cell: (row: any) => {
        return <div>{row?.metrics?.HBA1C}</div>;
      },
    },
  ];

  return (
    <div className="container-lg">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-3">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <Link to={`/users/${userId}/reports`} state={subscription}>
              Reports
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Metrics
          </li>
        </ol>
      </nav>
      {userDetails?.fullName && (
        <h6 className="fw-700 fs-24 mb-2">
          {userDetails?.fullName}'s health metrics
        </h6>
      )}

      <DataTableBase columns={columns} data={metrics} />
    </div>
  );
};

export default UserMetricsPage;
